import React from "react";
import "./Common_Card.css"

// Just declaring the fields here
const Common_Card = ({ icon, titleLine1, titleLine2, description }) => {
  return (
    <div className="edge-card">
      <div className="edge-icon">
        <img src={icon} alt="icon" className="icon" />
      </div>
      <h4 className="subheading">{titleLine1}</h4>
      <h4 className="subheading">{titleLine2}</h4>
      <p className="descriptionss">{description}</p>
    </div>
  );
};

export default Common_Card;